import type { ReactNode } from 'react';
import { X } from 'lucide-react';

interface UpgradeModalLayoutProps {
  left: ReactNode;
  right: ReactNode;
  onClose: () => void;
  showClose?: boolean;
}

export function UpgradeModalLayout({ left, right, onClose, showClose = true }: UpgradeModalLayoutProps) {
  const closeButton = showClose ? (
    <button
      type="button"
      onClick={onClose}
      aria-label="Close"
      className="vtwo:absolute vtwo:top-5 vtwo:right-5 vtwo:z-10 vtwo:size-10 vtwo:rounded-full vtwo:bg-black/80 vtwo:text-white vtwo:flex vtwo:items-center vtwo:justify-center vtwo:cursor-pointer vtwo:hover:bg-black/90 focus-ring"
    >
      <X className="vtwo:size-4" />
    </button>
  ) : null;

  return (
    <>
      {closeButton}
      <div className="vtwo:flex vtwo:flex-col vtwo:md:flex-row vtwo:max-h-[90vh] vtwo:overflow-y-auto">
        <div className="vtwo:flex-1 vtwo:p-10 vtwo:flex vtwo:flex-col vtwo:gap-6">{left}</div>
        <div className="vtwo:w-full vtwo:md:w-2/5 vtwo:shrink-0 vtwo:p-10 vtwo:flex vtwo:flex-col vtwo:items-center vtwo:justify-center vtwo:bg-linear-to-br vtwo:from-[#D6CCF8] vtwo:to-[#FFE3DF]">
          {right}
        </div>
      </div>
    </>
  );
}
